import React from 'react';
import Image from './Image';
import { bgColorClassname } from '@/utils';
import { ImageGrid as ImageGridType } from '@/types/SanityTypes';
import { Heading, RichText } from '@/components';

const ImageGrid: React.FC<ImageGridType> = ({ backgroundColor, heading, subheading, items }) => {
  return (
    <div
      className={
        backgroundColor?.label && backgroundColor?.value
          ? bgColorClassname(backgroundColor as { label: string; value: string })
          : ''
      }
    >
      <div className='mx-auto flex max-w-screen-xl flex-col gap-6 px-5 pb-8 pt-2 md:px-[50px]'>
        {heading && (
          <Heading
            title={heading as string}
            isShowCurveLine={true}
            className='mb-0'
          />
        )}
        {subheading && <RichText value={subheading} />}

        {items && items.length > 0 && (
          <div className='flex flex-wrap gap-5'>
            {items.map((item) => {
              const content = (
                <>
                  {item.image?.asset && (
                    <div className='relative aspect-square w-full overflow-hidden rounded-lg bg-white p-4 shadow-sm transition-all hover:shadow-md group-hover:scale-105'>
                      <Image
                        image={item.image as any}
                        alt={item.title || ''}
                        className='h-full w-full object-contain'
                      />
                    </div>
                  )}
                  {item.title && (
                    <h3 className='mt-3 text-center text-sm font-medium'>{item.title}</h3>
                  )}
                </>
              );

              return (
                <div
                  key={item._key}
                  className='group flex w-[150px] flex-col items-center md:w-[170px]'
                >
                  {item.link ? (
                    <a
                      href={item.link.externalLink || '#'}
                      className='flex flex-col items-center '
                      title={item.link.label || item.title || 'Visit link'}
                    >
                      {content}
                    </a>
                  ) : (
                    content
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageGrid;
